import BaseLayout from "../components/layout/layout-with-sider/BaseLayout";
import {Button, Popover, Radio, Result, Typography} from "antd";
import OperationMenu from "../app-components/OperationMenu";
import Icon, {SettingOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import GrayButton from "../components/GrayButton";
import MessageSelect from "../app-components/message/MessageSelect";
import {AppActions, useAppContext} from "../context/AppContext";
import MessageTab from "../app-components/message/MessageTab";
import OverviewPopup from "../components/OverviewPopup";
import {GetMessageCodeText} from "../app-components/outputs/MessageCodes";
import ResultListBox from "../app-components/outputs/ui/ResultListBox";
import PlotTab from "../app-components/message/PlotTab";
import MapTab from "../app-components/message/MapTab";
import {useHistory} from "react-router-dom";
import InfoTab from "../app-components/message/InfoTab";
import MessageSettings from "../app-components/message/MessageSettings";
import PopoverScrollContent from "../components/PopoverScrollContent";
import UITab from "../app-components/message/UITab";
import MessageSelectKeyboard from "../app-components/message/MessageSelectKeyboard";
import HecRasHelper from "../helpers/HecRasHelper";

export default function MessagePage() {
    const {appContext, filter, dispatchProject, getSelectedHistory, resetShapeFilters, selectedTab, selectedErrorId, selectedRS, selectedOperation, selectedHistoryId, previousOperation, getCSListByErrorId, getOperationByErrorId, getMessageCodeList, toolbarItem, getOperationItemConfig, getSelectedRS, getCSList} = useAppContext()
    const [messagePopup, setMessagePopup] = useState(false)
    const history = useHistory()
    const [messagePane, setMessagePane] = useState({
        open: false,
    })

    const getOperationItems = () => {
        const items = []
        getSelectedHistory()?.operations?.forEach(ops => {
            ops?.children?.forEach(child => {
                items.push(child)
            })
        })

        // console.log('getOperationItems', items)
        return items
    }

    const findNextPrev = (direction) => {
        const items = getOperationItems()
        let index = items.findIndex(x => x?.title === selectedOperation?.title)
        if(index < 0)
            index = 0

        if(index > -1) {
            if(direction === 'prev') {
                for (let i = index-1; i < index; i--) {
                    if(i < 0)
                        return null

                    const item = items[i]
                    if(item.hasError)
                        return item
                }
            }
            else if(direction === 'next') {
                for (let i = index+1; i < items.length; i++) {
                    const item = items[i]
                    if(item.hasError)
                        return item
                }
            }
        }

        return null
    }

    const hasNext = () => {
        const items = getOperationItems()
        let index = items.findIndex(x => x?.title === selectedOperation?.title)
        if(index > -1 && items.find((x, idx) => idx > index && x.hasError)) {
            return true
        }
        else if(index === -1) {
            return true
        }
    }

    const hasError = () => {
        for (const ops of getSelectedHistory()?.operations) {
            for (const child of ops.children) {
                if(child.hasError)
                    return true
            }
        }
    }

    const setSelectedOperation = (item) => {
        dispatchProject({
            type: AppActions.SET_SELECTED_OPERATION,
            data: {item}
        })
    }

    const setSelectedErrorId = (errorId) => {
        dispatchProject({
            type: AppActions.SET_SELECTED_ERROR_ID,
            data: {errorId}
        })
    }

    const setSelectedRS = (rs) => {
        dispatchProject({
            type: AppActions.SET_SELECTED_RS,
            data: {rs}
        })
    }

    const setSelectedTab = (tab) => {
        dispatchProject({
            type: AppActions.SET_TAB,
            data: {tab}
        })
    }

    const getMessageByRS = () => {
        const errMessage = selectedOperation?.data?.result?.find(x => GetMessageCodeText(selectedOperation?.key, x?.error_id) === selectedErrorId);
        const ops = {
            ...selectedOperation,
            data: {
                result: [
                    {
                        ...errMessage,
                        data: errMessage?.data?.filter(x => x.cross_section === getSelectedRS()?.cross_section)
                    }
                ]
            }
        }

        return {...ops}
    }

    const hasGeoReferenced = () => {
        if(getSelectedHistory()?.type === 'Comparison') {
            return HecRasHelper.hasGeoReferenced(getSelectedHistory()?.selection?.base?.plan?.geometry?.text) && HecRasHelper.hasGeoReferenced(getSelectedHistory()?.selection?.compare?.plan?.geometry?.text)
        }
        return HecRasHelper.hasGeoReferenced(getSelectedHistory()?.selection?.base?.plan?.geometry?.text)
    }

    useEffect(() => {
        if(appContext?.selectedHistoryId) {
            const items = getOperationItems()
            const item = items.find(x => x.title === selectedOperation?.title)
            setSelectedOperation(item)
        }
    }, [appContext?.selectedHistoryId]);

    useEffect(() => {
        if(!selectedOperation)
        {
            setSelectedTab('Message')
        }

        if(selectedOperation) {
            if(getMessageCodeList()?.length > 0) {
                setSelectedErrorId(getMessageCodeList()[0])
            }
        }
    }, [selectedOperation?.key]);

    useEffect(() => {
        const h = getSelectedHistory()
        if(!h?.id && appContext?.history?.length > 0) {
            dispatchProject({
                type: AppActions.SET_SELECTED_HISTORY_ID,
                data: {id: appContext?.history[appContext?.history?.length -1]?.id }
            })
        }
    }, [getSelectedHistory()]);

    // B/C tuşlarına basıldığında Map sekmesine geç
    useEffect(() => {
        const handleKeyDown = (e) => {
            // Input alanlarında çalışmasın
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
                return
            }

            // Skip if any modifier key is pressed (Ctrl, Alt, Shift, Meta)
            if (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) {
                return
            }

            const key = e.key.toLowerCase()
            if (key === 'b' || key === 'c') {
                // Map sekmesi geo-referenced değilse çalışmasın
                if (!hasGeoReferenced()) return
                
                // Compare data yoksa C tuşu çalışmasın
                const hasCompareData = !!getSelectedHistory()?.selection?.compare?.plan
                if (key === 'c' && !hasCompareData) return

                // Map sekmesine geç
                setSelectedTab('Map')
                
                // Map type'ı ayarla
                dispatchProject({
                    type: AppActions.SET_MAP_TYPE,
                    data: { mapType: key === 'b' ? 'base' : 'compare' }
                })
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [getSelectedHistory(), hasGeoReferenced])

    const getFilterType = () => {
        if(filter?.type === 'filter') {
            return 'Filter'
        }
        else if(filter?.type === 'highlight') {
            return 'Highlight'
        }
    }

    // useEffect(() => {
    //     resetShapeFilters('automation')
    // }, []);

    return (
        <BaseLayout>
            {
                appContext?.history?.length === 0 && (
                    <Result
                        style={{backgroundColor: 'white'}}
                        title="There are no Run Results!"
                        extra={
                            <>
                                <Button
                                    size={'small'}
                                    type="primary"
                                    key="console2"
                                    onClick={() => {history.push('/app/load-project')}}
                                >
                                    Upload project and run
                                </Button>
                            </>
                        }
                    />
                )
            }
            {
                appContext?.history?.length > 0 && (
                    <div style={{backgroundColor: 'white'}}>
                        <div style={{display: 'flex', alignItems: 'center', paddingRight: 16}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: 16, flex: 1}}>
                                <div>
                                    <Popover
                                        placement={'bottomLeft'}
                                        trigger={'click'}
                                        content={(
                                            <PopoverScrollContent maHeight={window.innerHeight - 400}>
                                                <MessageSelect type={'Table'}/>
                                            </PopoverScrollContent>
                                        )}
                                    >
                                        <GrayButton
                                            style={{width: 100}}
                                        >
                                            <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                                Run Results
                                            </div>
                                        </GrayButton>
                                    </Popover>
                                    <Popover
                                        trigger={'click'}
                                        placement={'bottomLeft'}
                                        content={(
                                            <PopoverScrollContent
                                                style={{width: 1450}}
                                                maxHeight={window.innerHeight - 200}
                                            >
                                                <OperationMenu
                                                    selected={selectedOperation}
                                                    onClick={(item) => setSelectedOperation(item)}
                                                    disableCheck={true}
                                                    operations={getSelectedHistory()?.operations || []}
                                                />
                                            </PopoverScrollContent>
                                        )}
                                    >
                                        <GrayButton>
                                            {selectedOperation?.title || 'Overview'}
                                        </GrayButton>
                                    </Popover>
                                </div>
                                <div>
                                    <Button
                                        disabled={!hasError() || !selectedOperation}
                                        icon={(hasError() && selectedOperation) ? <Icon component={() => <PrevLogo/>}/> :
                                            <Icon component={() => <PrevDisabledLogo/>}/>} type={'text'}
                                        onClick={() => setSelectedOperation(findNextPrev('prev'))}
                                    />
                                    <Button
                                        disabled={!hasError() || !hasNext()}
                                        icon={hasError() ? <Icon component={() => <NextLogo/>}/> :
                                            <Icon component={() => <NextDisabledLogo/>}/>} type={'text'}
                                        onClick={() => setSelectedOperation(findNextPrev('next'))}
                                    />
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                    <Popover
                                        placement={'bottomLeft'}
                                        trigger={'click'}
                                        content={<MessageSettings/>}
                                    >
                                        <Button
                                            size={'small'}
                                            type={'primary'}
                                            icon={<SettingOutlined/>}
                                        />
                                    </Popover>
                                    {
                                        filter?.type !== 'clear' && (
                                            <Typography.Text>
                                                {selectedHistoryId && (
                                                    <>
                                                        {getFilterType()}: {filter?.ds} - {filter?.us}
                                                    </>
                                                )}
                                            </Typography.Text>
                                        )
                                    }
                                </div>
                            </div>
                            <div style={{display: selectedOperation ? 'flex' : 'none', alignItems: 'center', gap: 8}}>
                                <Popover
                                    trigger={'click'}
                                    content={(
                                        <PopoverScrollContent maxHeight={window.innerHeight - 400}>
                                            <div style={{maxWidth: '22cm'}}>
                                                <OverviewPopup/>
                                            </div>
                                        </PopoverScrollContent>
                                    )}
                                    placement={'bottomLeft'}
                                >
                                    <GrayButton
                                        style={{width: 75, height: 24}}
                                    >
                                        Overview
                                    </GrayButton>
                                </Popover>
                                <Radio.Group
                                    onChange={(e) => {
                                        setSelectedTab(e.target.value)
                                    }}
                                    value={selectedTab}
                                    optionType="button"
                                    buttonStyle="solid"
                                    size={'small'}
                                >
                                    {
                                        selectedTab !== 'Message' && (
                                            <Radio value={'Message'} style={{width: 75}}>
                                                Message
                                            </Radio>
                                        )
                                    }
                                    <Radio value={'Plot'} style={{width: 75}}>
                                        Plot
                                    </Radio>
                                    <Radio value={'UI'} style={{width: 75}}>
                                        UI
                                    </Radio>
                                    <Radio value={'Map'} style={{width: 75}} disabled={!hasGeoReferenced()}>
                                        Map
                                    </Radio>
                                    <Radio value={'Info'} style={{width: 75}}>
                                        Info
                                    </Radio>
                                </Radio.Group>
                            </div>
                        </div>
                        <div style={{
                            display: (!selectedOperation || selectedTab === 'Message') ? 'none' : 'flex',
                            alignItems: 'center',
                            gap: 8,
                            marginTop: 4,
                            paddingRight: 16
                        }}>
                            <div style={{display: 'flex', alignItems: 'center', flex: 1, gap: 8, marginBottom: 4}}>
                                <ResultListBox
                                    suffixIcon={(<b style={{marginRight: 16}}>Messages</b>)}
                                    value={selectedErrorId}
                                    list={getMessageCodeList()}
                                    onChange={(val) => {
                                        if(val) {
                                            setSelectedErrorId(val)
                                        }
                                    }}
                                    width={200}
                                />
                                <ResultListBox
                                    suffixIcon={(<b style={{marginRight: 16}}>River Station</b>)}
                                    value={selectedRS}
                                    list={getCSListByErrorId()}
                                    otherData={getCSList().map(c => c.name)}
                                    onChange={(val) => {
                                        setSelectedRS(val)
                                    }}
                                    width={200}
                                    selectProps={{
                                        allowClear: true,
                                        showSearch: true
                                    }}
                                />
                                {toolbarItem}
                            </div>
                            <div>
                                <Popover
                                    trigger={'click'}
                                    placement={'bottomLeft'}
                                    open={messagePopup && selectedTab !== 'Message'}
                                    content={(
                                        <PopoverScrollContent maxHeight={window.innerHeight - 400} style={{width: '12cm'}}>
                                            <MessageTab
                                                type={selectedOperation?.type}
                                                operation={getMessageByRS()}
                                            />
                                        </PopoverScrollContent>
                                    )}
                                >
                                    <GrayButton
                                        style={{width: 458, height: 24}}
                                        onClick={() => {
                                            setMessagePopup(!messagePopup)
                                        }}
                                    >
                                        <b>Message Code: {selectedErrorId}</b>
                                    </GrayButton>
                                </Popover>
                            </div>
                        </div>
                        <div>
                            {
                                selectedTab === "Message" && (
                                    <MessageTab
                                        operation={selectedOperation}
                                        type={getSelectedHistory()?.type}
                                    />
                                )
                            }
                            {
                                selectedTab === "Plot" && (
                                    <PlotTab/>
                                )
                            }
                            {
                                selectedTab === "UI" && (
                                    <UITab/>
                                )
                            }
                            {
                                selectedTab === "Map" && (
                                    <MapTab/>
                                )
                            }
                            {
                                selectedTab === "Info" && (
                                    <InfoTab/>
                                )
                            }
                        </div>
                    </div>
                )
            }
            <MessageSelectKeyboard/>
        </BaseLayout>
    )
}

const NextLogo = ({}) => {
    return (
        <img width={24} height={24}
             src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyNDcgLTI5NikiPjxwYXRoIGQ9Ik00MjYxIDY0MEM0MjYxIDQ1Ny43NDYgNDQwOC43NSAzMTAgNDU5MSAzMTAgNDc3My4yNSAzMTAgNDkyMSA0NTcuNzQ2IDQ5MjEgNjQwIDQ5MjEgODIyLjI1NCA0NzczLjI1IDk3MCA0NTkxIDk3MCA0NDA4Ljc1IDk3MCA0MjYxIDgyMi4yNTQgNDI2MSA2NDBaIiBzdHJva2U9IiMwMzU3ODEiIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik00NTE3LjA4IDgxMi42MDQgNDcxMC4yNiA2NDMuODI4IiBzdHJva2U9IiMwMzU3ODEiIHN0cm9rZS13aWR0aD0iNTUiIHN0cm9rZS1taXRlcmxpbWl0PSI4IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJNMCAwIDI4MC43NjQgMC4wMDAzNjA4OTIiIHN0cm9rZT0iIzAzNTc4MSIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJtYXRyaXgoMC42NTc5MzYgMC43NTMwNzQgMC43NTMwNzQgLTAuNjU3OTM2IDQ1MjQuNzcgNDYzLjcwMSkiLz48L2c+PC9zdmc+'}/>
    )
}

const NextDisabledLogo = ({}) => {
    return (
        <img width={24} height={24}
             src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyNDcgLTI5NikiPjxwYXRoIGQ9Ik00MjYxIDY0MEM0MjYxIDQ1Ny43NDYgNDQwOC43NSAzMTAgNDU5MSAzMTAgNDc3My4yNSAzMTAgNDkyMSA0NTcuNzQ2IDQ5MjEgNjQwIDQ5MjEgODIyLjI1NCA0NzczLjI1IDk3MCA0NTkxIDk3MCA0NDA4Ljc1IDk3MCA0MjYxIDgyMi4yNTQgNDI2MSA2NDBaIiBzdHJva2U9IiNiZGMzYzciIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik00NTE3LjA4IDgxMi42MDQgNDcxMC4yNiA2NDMuODI4IiBzdHJva2U9IiNiZGMzYzciIHN0cm9rZS13aWR0aD0iNTUiIHN0cm9rZS1taXRlcmxpbWl0PSI4IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJNMCAwIDI4MC43NjQgMC4wMDAzNjA4OTIiIHN0cm9rZT0iI2JkYzNjNyIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJtYXRyaXgoMC42NTc5MzYgMC43NTMwNzQgMC43NTMwNzQgLTAuNjU3OTM2IDQ1MjQuNzcgNDYzLjcwMSkiLz48L2c+PC9zdmc+'}/>
    )
}

const PrevLogo = ({}) => {
    return (
        <img width={24} height={24}
             src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0MDQgLTI5NikiPjxwYXRoIGQ9Ik0zNDE4IDY0MEMzNDE4IDQ1Ny43NDYgMzU2NS43NSAzMTAgMzc0OCAzMTAgMzkzMC4yNSAzMTAgNDA3OCA0NTcuNzQ2IDQwNzggNjQwIDQwNzggODIyLjI1NCAzOTMwLjI1IDk3MCAzNzQ4IDk3MCAzNTY1Ljc1IDk3MCAzNDE4IDgyMi4yNTQgMzQxOCA2NDBaIiBzdHJva2U9IiMwMzU3ODEiIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0zNzk4LjQ1IDQ2Ni4wOCAzNjI3Ljk3IDY1Ny43NjMiIHN0cm9rZT0iIzAzNTc4MSIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0wIDAgMjgwLjc2NCAwLjAwMDM2MDg5MiIgc3Ryb2tlPSIjMDM1NzgxIiBzdHJva2Utd2lkdGg9IjU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iOCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43NDcyMzEgLTAuNjY0NTY1IC0wLjY2NDU2NSAwLjc0NzIzMSAzODM0LjU5IDgxMy4xOTIpIi8+PC9nPjwvc3ZnPg=='}/>
    )
}

const PrevDisabledLogo = ({}) => {
    return (
        <img width={24} height={24}
             src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0MDQgLTI5NikiPjxwYXRoIGQ9Ik0zNDE4IDY0MEMzNDE4IDQ1Ny43NDYgMzU2NS43NSAzMTAgMzc0OCAzMTAgMzkzMC4yNSAzMTAgNDA3OCA0NTcuNzQ2IDQwNzggNjQwIDQwNzggODIyLjI1NCAzOTMwLjI1IDk3MCAzNzQ4IDk3MCAzNTY1Ljc1IDk3MCAzNDE4IDgyMi4yNTQgMzQxOCA2NDBaIiBzdHJva2U9IiNiZGMzYzciIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0zNzk4LjQ1IDQ2Ni4wOCAzNjI3Ljk3IDY1Ny43NjMiIHN0cm9rZT0iI2JkYzNjNyIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0wIDAgMjgwLjc2NCAwLjAwMDM2MDg5MiIgc3Ryb2tlPSIjYmRjM2M3IiBzdHJva2Utd2lkdGg9IjU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iOCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43NDcyMzEgLTAuNjY0NTY1IC0wLjY2NDU2NSAwLjc0NzIzMSAzODM0LjU5IDgxMy4xOTIpIi8+PC9nPjwvc3ZnPg=='}/>
    )
}